import React from "react";
import Card from "react-bootstrap/Card";

import './Resume.css'

function Resume_Work() {
  return (
    <>
      <Card className={"resume-card"}>
        <h1 className={"resume-card-title"}>Work Experiences</h1> <br></br>
        <div className={"resume-card-contents"}>
          <h4>2024.05 ~ </h4>
          <h5>Warker Chemical Korea</h5>
          <h6>Business System Analyst, IT</h6>
            <p style={{textAlign:"left"}}>
                        <b>주요 역할</b> <br></br>
                          사내 소프트웨어 담당자 <br></br> <br></br>

                        <b>주요 업무 / 성과</b> <br></br>
                          - 사용자 요구사항 분석 <br></br>
                          - 소프트웨어 아키텍처 / 프로세스 분석 <br/>
                          - SAP 오류 분석 및 해결 방안 공유 <br />
                          - 사내 소프트웨어 및 보안 교육 <br /> 
                          - RPA 개발<br></br> <br></br>

                        <b>성과 및 배운 점</b> <br></br>
                           - SAP Migration Project 수행 <br></br>
             </p>
          <hr></hr>
        </div>
        <div className={"resume-card-contents"}>
          <h4>2022.11 ~ 2024.04</h4>
          <h5>교보 DTS</h5>
          <h6>보험기술운영1팀 사원</h6>
          <p style={{ textAlign: "left" }}>
            <b>주요 역할</b> <br></br>
            교보생명 자산운용 파트 시스템 운영 직무 <br></br> <br></br>
            <b>주요 업무 / 성과</b> <br></br>
            SAP ABAP을 기반으로 하는 SAP 회계 부동산 시스템 운영 업무 수행 <br></br> <br></br>
            <b>성과 및 배운 점</b> <br></br>
            1. 시스템 사용자의 편의를 위해 현업의 요구에 맞춰 시스템 개선(임대 계약, 임차료 관련 산출 로직 개선) 업무 진행 <br></br>
            2. IT 감사를 위한 시스템 운영자 메뉴얼(테이블 설계도, 프로그램 / 함수 그룹 설계도 / 인터페이스 현황) 현행화 수행 <br></br> <br></br>
          </p>
          <hr></hr>
        </div>
        <div className={"resume-card-contents"}>
          <h4>2022.01 ~ 2022.06</h4>
          <h5>RCI Financial Services Korea</h5>
          <h6>IT infra팀 인턴</h6>
          <p style={{ textAlign: "left" }}>
            <b>주요 역할</b> <br></br>
            사내 IT infra 운영 및 관리 지원 <br></br> <br></br>
            <b>주요 업무 / 성과</b> <br></br>
            1. 사내 업무망 및 업무망 서버 관리 <br></br>
            2. OA 업무 데이터 분석 <br></br>
            3. 데이터 분석 기반 OA 업무 프로세스 개선 <br></br> <br></br>

            <b>성과 및 배운 점</b> <br></br>
            1, 사내 프로세스 문서화 <br></br>
            2. OA 업무 기록 자동화 시스템 구측 지원을 통한 OA 업무 프로세스 효율성 증대 <br></br> <br></br>
          </p>
          <hr></hr>
        </div>
        <div className={"resume-card-contents"}>
          <h4>2020.12 ~ 2021.2</h4>
          <h5>(주) 랫유인</h5>
          <h6>SW 사업부 콘텐츠 랩 인턴</h6>
          <p style={{ textAlign: "left" }}>
            <b>주요 역할</b> <br></br>
            고객 데이터 분석, 데이터 분석 기반 콘텐츠 기획 및 제작 <br></br>
            <br></br>
            <b>주요 업무 / 성과</b> <br></br>
            : 고객 커뮤니티 운영 및 관리 <br></br>
            : 고객 리뷰 / 커뮤니티 데이터 분석 <br></br>
            : 고객 데이터 분석을 기반으로 콘텐츠 기획 및 제작 <br></br>
            <br></br>
            <b>성과 및 배운 점</b> <br></br>
            : 고객 데이터 분석을 통한 커뮤니티 이용자 증가(400 → 600) <br></br>
            : 데이터 분석 방법론 및 분석 결과, 실무적용 방법, 경험 및 관련 지식 배양
          </p>
        </div>
      </Card>
    </>
  );
}

export default Resume_Work;
